import { render, staticRenderFns } from "./BanatDeutsche.vue?vue&type=template&id=39ecc716&"
import script from "./BanatDeutsche.vue?vue&type=script&lang=js&"
export * from "./BanatDeutsche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports